<template>
  <FormSelect
    :disabled="disabled"
    :loading="loading"
    :name="$t('meta.fraction')"
    :options="fractionOptions"
    :required="required"
    :value="value"
    @input="$emit('input', $event)"
  />
</template>

<script>
import FormSelect from '@/components/Form/Select/index.vue'

import fractionsApi from '@/api/companies/fractions'

export default {
  name: 'FractionSelect',
  components: { FormSelect },
  data: () => ({
    fractions: null,
    loading: true,
  }),
  props: {
    value: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    companyUuid: { type: String, default: null },
    selectableInOrders: { type: Boolean, default: false },
  },
  computed: {
    fractionOptions() {
      return this.fractions?.map(fraction => ({
        label: fraction.localized_name,
        value: fraction.uuid,
      }))
    },
  },
  watch: {
    companyUuid: {
      async handler() {
        if (this.companyUuid) {
          if (this.selectableInOrders) {
            this.fractions = await fractionsApi.getAll(this.companyUuid, { selectable_in_orders: true })
          } else {
            this.fractions = await fractionsApi.getAll(this.companyUuid)
          }

          this.loading = false
        } else {
          this.fractions = []
        }
      },
      immediate: true,
    },
  },
}
</script>
